module.exports = __webpack_public_path__ + "img/pc.34576b7c.png";